// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
/* Limit the size of images inside the editor */
.ProseMirror img {
  max-width: 100%;
  max-height: 150px;
  height: auto;
  width: auto;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 2px;
}

.email-preview-content img {
  max-width: 100%;
  max-height: 350px;
  height: auto;
  width: auto;
  object-fit: contain;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.custom-swal-zindex {
    z-index: 99999 !important;
}

/* SweetAlert2 must always stack above MUI Dialog/Modal (MUI modal z-index ~1300, Swal default ~1060) */
.swal2-container {
    z-index: 99999 !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA,+CAA+C;AAC/C;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;IACI,yBAAyB;AAC7B;;AAEA,uGAAuG;AACvG;IACI,yBAAyB;AAC7B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n/* Limit the size of images inside the editor */\n.ProseMirror img {\n  max-width: 100%;\n  max-height: 150px;\n  height: auto;\n  width: auto;\n  object-fit: contain;\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  padding: 2px;\n}\n\n.email-preview-content img {\n  max-width: 100%;\n  max-height: 350px;\n  height: auto;\n  width: auto;\n  object-fit: contain;\n  display: inline-block;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n.custom-swal-zindex {\n    z-index: 99999 !important;\n}\n\n/* SweetAlert2 must always stack above MUI Dialog/Modal (MUI modal z-index ~1300, Swal default ~1060) */\n.swal2-container {\n    z-index: 99999 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
